import React from 'react';

const CasinoV2 = () => /* @__PURE__ */ React.createElement(
  "svg",
  {
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  },
  /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_17206_46145)" }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M10.0009 7.08523L12.0847 10.0026L10.0009 12.92L7.91703 10.0026L10.0009 7.08523Z",
      fill: "white"
    }
  ), /* @__PURE__ */ React.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M19.1698 10.0027C19.1698 15.0666 15.0647 19.1716 10.0009 19.1716C4.93708 19.1716 0.832031 15.0666 0.832031 10.0027C0.832031 4.93891 4.93708 0.833862 10.0009 0.833862C15.0647 0.833862 19.1698 4.93891 19.1698 10.0027ZM9.37572 17.897V15.8047C7.72215 15.6293 6.27478 14.7632 5.3276 13.5003L3.52893 14.5665C4.84986 16.4363 6.96068 17.7084 9.37572 17.897ZM2.89034 13.4916L4.68876 12.4256C4.35148 11.6876 4.16352 10.8671 4.16352 10.0027C4.16352 9.13906 4.35118 8.3192 4.68794 7.58172L2.88947 6.51569C2.3726 7.56781 2.08233 8.75138 2.08233 10.0027C2.08233 11.2548 2.37292 12.439 2.89034 13.4916ZM3.5278 5.44061L5.32642 6.50673C6.27358 5.24304 7.72147 4.37628 9.37572 4.20083V2.10848C6.95999 2.29716 4.84865 3.5699 3.5278 5.44061ZM16.4724 14.5671C15.1514 16.4366 13.0408 17.7084 10.626 17.897V15.8041C12.2781 15.6274 13.7239 14.7611 14.6701 13.4988L16.4724 14.5671ZM17.1111 13.4923C17.6288 12.4395 17.9195 11.2551 17.9195 10.0027C17.9195 8.75109 17.6291 7.56727 17.112 6.51497L15.3094 7.58346C15.6456 8.32049 15.833 9.13974 15.833 10.0027C15.833 10.8665 15.6453 11.6863 15.3085 12.4238L17.1111 13.4923ZM16.4736 5.43995L14.6712 6.50826C13.7251 5.24507 12.2788 4.37818 10.626 4.20138V2.10848C13.0415 2.29711 15.1527 3.56958 16.4736 5.43995ZM9.99826 14.5872C12.5302 14.5872 14.5827 12.5347 14.5827 10.0027C14.5827 7.47083 12.5302 5.41831 9.99826 5.41831C7.46634 5.41831 5.41382 7.47083 5.41382 10.0027C5.41382 12.5347 7.46634 14.5872 9.99826 14.5872Z",
      fill: "white"
    }
  )),
  /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("clipPath", { id: "clip0_17206_46145" }, /* @__PURE__ */ React.createElement("rect", { width: "20", height: "20", fill: "white" })))
);

export { CasinoV2 };
//# sourceMappingURL=CasinoV2.js.map
